module.exports = __webpack_public_path__ + "img/1487341320.81435571.jpg";